import {Button} from 'antd'
import {useReadOnly} from './ReadOnly.mjs'

export default function SwitchButton({
    disabled,
    options,
    value,
    onChange,
    ...props
}) {
    const gReadOnly = useReadOnly()

    const i = (() => {
        if (void 0 === value) {
            return 0
        }

        const i = options.findIndex(([v]) => v === value)
        return -1 < i ? i : 0
    })()

    const [, children = value] = options[i]

    const onClick = () => {
        const j = i + 1 < options.length ? i + 1 : 0
        const [value] = options[j]
        onChange?.(value)
    }

    return (
        <Button
            disabled={disabled || gReadOnly}
            onClick={onClick}
            {...props}
        >
            {children}
        </Button>
    )
}
